export default "__VITE_ASSET__C0rXkA2I__"